import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { FiSettings } from "react-icons/fi";

export default function ThemeSelector() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const {
    themeName,
    setThemeName,
    presets,
    customBg,
    setCustomBg,
    customHighlight,
    setCustomHighlight,
  } = useTheme();

  const presetKeys = ["light", "dark", "blue"];

  return (
    <div ref={panelRef} style={{ position: "relative", zIndex: 999 }}>
      <button
        className="theme-toggle-btn"
        onClick={() => setOpen(!open)}
        title="Theme Settings"
      >
        <FiSettings size={18} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="theme-panel-v2"
            initial={{ opacity: 0, y: 8, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ duration: 0.15 }}
          >
            {/* Theme presets as horizontal pills */}
            <div className="tp-section-label">Theme</div>
            <div className="tp-presets">
              {presetKeys.map((key) => {
                const preset = presets[key];
                const active = themeName === key;
                return (
                  <button
                    key={key}
                    className={`tp-pill ${active ? "tp-pill-active" : ""}`}
                    onClick={() => setThemeName(key)}
                  >
                    <span
                      className="tp-dot"
                      style={{
                        background: `linear-gradient(135deg, ${preset.bg}, ${preset.highlight})`,
                      }}
                    />
                    {preset.name}
                  </button>
                );
              })}
            </div>

            {/* Custom colors inline */}
            <div className="tp-section-label" style={{ marginTop: "10px" }}>Custom</div>
            <div className="tp-custom-row">
              <label className="tp-color-label">
                BG
                <input
                  type="color"
                  value={customBg}
                  onChange={(e) => {
                    setCustomBg(e.target.value);
                    setThemeName("custom");
                  }}
                  className="tp-color-input"
                />
              </label>
              <label className="tp-color-label">
                HL
                <input
                  type="color"
                  value={customHighlight}
                  onChange={(e) => {
                    setCustomHighlight(e.target.value);
                    setThemeName("custom");
                  }}
                  className="tp-color-input"
                />
              </label>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
